/**
 * Angular imports.
 */
import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

/**
 * Model imports.
*/
import { Ratings } from '../../onboarding/interface/global.model';

@Component({
  selector: 'app-multi-choice-grid',
  templateUrl: './multi-choice-grid.component.html',
  styleUrls: ['./multi-choice-grid.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MultiChoiceGridComponent implements OnInit {

  /**
   * Receive the ratings array.
   * Number of rows to show.
   * Number of columns to show.
   */
  @Input() values: Ratings;
  @Input() name: string;
  @Input() rows = [];
  @Input() columns = [];
  @Input() isViewMode: boolean;
  @Input() prefilled = [];

  /**
   * Send selected rating outside.
   */
  @Output() emitSelected: EventEmitter<{ row: { code: number }; column: number }> = new EventEmitter();

  public ratings: Ratings;

  ngOnInit(): void {
    this.ratings = JSON.parse(JSON.stringify(this.values));
  }

  /**
   * Receive the selected rating and send selected.
   */
  setRating(rowIndex: number, columnIndex: number): void {
    if (!this.checkIsViewMode()) {
      this.sendSelected(rowIndex, columnIndex);
    }
  }

  /**
   * Send selected rating outside.
   */
  sendSelected(rowIndex: number, columnIndex: number): void {
    this.emitSelected.emit({ row: this.rows[rowIndex], column: columnIndex });
  }

  checkIsViewMode(): boolean {
    return this.isViewMode;
  }

  /**
   * Track the indexed stream.
   */
  trackById(index, ques): void {
    return ques ? ques.id : undefined;
  }
  /**
   * Track the indexed stream.
   */
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  trackByIndex(index, ques): void {
    return index;
  }

  getSelected(index: number, id: string): boolean {
    return this.prefilled?.length ? (this.prefilled.some(val => (index === (Number(val?.textValue) - 1) && id === val?.optionCode))) : false;
  }
}
